import React from "react";
import BannerStrip from "../../components/Banner/BannerStrip";
import CategoriesFeatured from "../../components/Categories/CategoriesFeatured";
import ProductsCarousell from "../../components/Carousell/products/ProductsCarousell";
import FeaturedProducts from "../../components/Carousell/features/FeaturedProducts";
import styles from "./home.module.css";
import AdsPage from "../ads/ads";
import TalkWithUs from "../talkWithUs/talk";
import BannerOnca from "../bannerOnca/banner";
import MochilaBanner from "../instagramRole/instagram";
import LogoBanner from "../logo/logoBanner";

function Home() {
    return (
            <div className={styles.background}>
            <LogoBanner />    
            <BannerStrip />
            <CategoriesFeatured />
            <FeaturedProducts /> 
            <BannerOnca />
            <ProductsCarousell />
            <MochilaBanner />
            <TalkWithUs />
            <AdsPage />
        </div>
    )
};

export default Home;